
import React,{ createContext, useState, useCallback, ReactElement } from 'react';

export const FieldTableSettingsContext = createContext(null);

export type FieldTableSettingsContextValue = {
    register:any,
    registerType:(any)=>null
};


export function FieldTableSettingsContextProvider({children}): ReactElement {
    const [value,setValue] = useState({register:{},registerType:null});
    const registerType = useCallback((newType:any)=>{
        setValue((v)=>{
            v.register = Object.assign({},v.register);
            v.register[newType.dataType] = newType;
            return v;
        });
    },[]);
    value.registerType = registerType;
    return <FieldTableSettingsContext.Provider value={value}>{children}</FieldTableSettingsContext.Provider>;
}
